<template>

<section class="hero" id="heroSection">

    <!-- =============================== -->
    <!-- BANNER -->
    <!-- =============================== -->

    <div class="hero-banner">

        <div class="hero-chip">
            THE WORLD’S POLE DANCE LIBRARY
        </div>

        <h1 class="hero-title">
            Pole App
        </h1>

        <p class="hero-subtitle">
            Everything you need
            <br>
            in one place.
        </p>

    </div>

    <!-- =============================== -->
    <!-- TRUCO DEL DÍA -->
    <!-- =============================== -->

    <section
        v-if="trickOfTheDay && trickOfTheDay.truco"
        class="featured"
    >

        <section
            class="featured-image"
            :style="trickImageStyle"
        >

            <span class="featured-label">
                TRICK OF THE DAY
            </span>

            <div class="featured-overlay">

                <div class="featured-content">

                    <span class="featured-level">
                        {{ trickOfTheDay.truco.dificultad.nombre }}
                    </span>

                    <h2>
                        {{ trickOfTheDay.truco.nombre }}
                    </h2>

                    <p>
                        Discover today's featured trick and learn new variations step by step.
                    </p>

                    <v-btn
                        color="white"
                        rounded
                        large
                        class="black--text font-weight-bold"
                        @click="verFigura"
                    >
                        View trick
                    </v-btn>

                </div>

            </div>

        </section>

    </section>

</section>

</template>

<script>

import TrucoService from "../../service/TrucoService";
import { urlBase } from "../../service/Api";

export default {

    name: "HeroSection",

    data() {

        return {

            trickOfTheDay: null,

            levels: [

                {
                    title: "Beginner"
                },

                {
                    title: "Intermediate"
                },

                {
                    title: "Advanced"
                },

                {
                    title: "Legend"
                }

            ]

        };

    },

    computed: {

         trickImageStyle() {

            const portada = this.trickOfTheDay?.truco?.portada;

            if (!portada || !portada.ruta) {
                return {};
            }

            const backendUrl = urlBase.replace(/\/api\/?$/, "");

            const url = `${backendUrl}/storage/${portada.ruta}`;

            console.log("URL IMAGEN:", url);

            return {
                backgroundImage: `url("${url}")`
            };
        }

    },

    mounted() {

        this.obtenerTrucoDelDia();

    },

    methods: {

        verFigura() {

            const truco = this.trickOfTheDay?.truco;

            console.log("CLICK HERO TRICK:", truco);

            if (!truco || !truco.slug) {
                console.error("El truco del día no tiene slug");
                return;
            }

            this.$router.push(
                `/trick/${truco.slug}`
            );

        },

        async obtenerTrucoDelDia() {

            try {

                const respuesta =
                    await TrucoService.obtenerTrucoDelDia();

                this.trickOfTheDay = respuesta.data;

                console.log(
                    "TRICK OF THE DAY:",
                    this.trickOfTheDay
                );

                console.log("RESPUESTA:", respuesta.data);
                console.log("TRUCO:", this.trickOfTheDay.truco);
                console.log("PORTADA:", this.trickOfTheDay.truco.portada);

            } catch (error) {

                console.error(
                    "Error obteniendo el truco del día:",
                    error
                );

            }

        },

    },

};

</script>

<style scoped>

.hero{


    min-height:calc(100svh - 4rem);

    min-height:100svh;

    display:grid;

    grid-template-rows:auto 1fr;

    gap:1rem;

    padding:1.5rem;

    background:#0F0F0F;

}

/* ===================================== */
/* BANNER */
/* ===================================== */

.hero-banner{

    background:#0F0F0F url("@/assets/images/PoleDancerBackgroundBanner.jpg") center center/cover no-repeat;

    display:flex;

    flex-direction:column;

    align-items:center;

    text-align:center;

}

.hero-chip{

    position:absolute;

    top:1.5rem;

    left:2rem;

    display:inline-block;

    align-items:center;

    padding:.55rem 1rem;

    border-radius:999px;

    background:#181818;

    color:#D0D0D0;

    font-size:.8rem;

    letter-spacing:.08em;

    margin-top:1rem;

    margin-bottom:1rem;

}

.hero-title{

    color:#FFF;

    font-size:clamp(2.7rem,5vw,4.8rem);

    font-weight:900;

    line-height:1;

    margin-top:2rem;

    margin-bottom:.75rem;

}

.hero-subtitle{

    color:#BDBDBD;

    font-size:clamp(0.8rem,1.5vw,1.25rem);

    line-height:1.6;

}

/* ===================================== */
/* TRUCO DEL DIA */
/* ===================================== */

.featured{

    display:flex;

    flex-direction:column;

    min-height:0;

}

.featured-header{

    display:flex;

    justify-content:space-between;

    align-items:center;

    margin-bottom:1rem;

}

.featured-label{

    color:#E50914;

    font-size:.9rem;

    font-weight:700;

    letter-spacing:.08em;

}

.featured-image{

    flex:1;

    min-height:0;

    position:relative;

    overflow:hidden;

    border-radius:24px;

    background:url("@/assets/images/home.jpg") center center/cover no-repeat;

}

.featured-overlay{

    position:absolute;

    inset:0;

    display:flex;

    align-items:flex-end;

    padding:2rem;

    background:linear-gradient(

        to top,

        rgba(0,0,0,.92),

        rgba(0,0,0,.45),

        rgba(0,0,0,.10)

    );

}

.featured-content{

    max-width:36rem;

}

.difficulty{

    display:inline-block;

    padding:.45rem .9rem;

    margin-bottom:1rem;

    border-radius:999px;

    background:rgba(255,255,255,.15);

    color:#FFF;

    font-size:.8rem;

}

.featured-content h2{

    color:#FFF;

    font-size:clamp(2rem,4vw,3.4rem);

    font-weight:800;

    margin-bottom:1rem;

}

.featured-content p{

    color:#D5D5D5;

    line-height:1.7;

    margin-bottom:2rem;

}

/* ===================================== */
/* MOBILE */
/* ===================================== */

@media(max-width:600px){

    .hero{

        padding:1rem;

        gap:.75rem;

    }

    .hero-chip {
        position: absolute;
        top: auto;
        left: auto;
    }

    .hero-title{

        font-size:2.5rem;

        margin-top:5rem;

    }

    .hero-subtitle{

        font-size:1rem;

    }

    .featured-overlay{

        padding:1.25rem;

    }

    .featured-content h2{

        font-size:1.9rem;

    }

    .featured-content p{

        font-size:.95rem;

    }

}

</style>